module.exports = __webpack_public_path__ + "img/13.8bd5c4f5.webp";